import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import WereAlwaysOnline from "./sections/WereAlwaysOnline";
import NationalFootprint from "./sections/NationalFootprint";
import ServiceRequestCenter from "./sections/ServiceRequestCenter";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <WereAlwaysOnline />
      <NationalFootprint />
      <ServiceRequestCenter />
      <Footer />
    </div>;
}